'use strict';

import { Action, BASKETS_PAYMENT_REMINDER } from "../../services/messagesService/messagesService.service";
import { IMessagesService, IMessage } from '../../interfaces';

const angular = require('angular');

export class adminBasketsMessagesComponent{
  $http: ng.IHttpService;
  MessagesService: IMessagesService;
  
  message: IMessage;

  actions: Action[] = [];
  selectedAction: any;
  baskets: any[] = [];

  alert: string;

  /*ngInjector*/
  constructor($http, MessagesService)
  {
    this.$http = $http;
    this.MessagesService = MessagesService;
  }

  $onInit() {
    let resolve = (this as any).resolve;
    if (_.has(resolve, 'filteredBaskets') && resolve.filteredBaskets !== null) {
      this.baskets = resolve.filteredBaskets;
    }

    this.selectedAction = null;
    this.alert = null;
    this.reload();
  }

  reload() {
    this.actions = this.MessagesService.getBasketActions();
  }

  getMessage(action) {
    this.alert = null;
    this.selectedAction = action;

    this.message = this.MessagesService.getBasketMessage(this.selectedAction);
  }

  saveMessage(form) {
    if(form.$valid) {
      this.MessagesService.setBasketMessage(this.message)
      .then( () => {
        this.alert = "The message has been successfully saved!"
      });
    }
  }

  isSendMail() {
    return this.selectedAction.name == BASKETS_PAYMENT_REMINDER;
  }

  sendMail(form) {
    let basketsSelected = this.baskets.filter(b => b.$selected);//.map(b => b.membership._id);
    
    //remove duplicates
    let membershipIds: any[] = [];
    _.each(_.map(basketsSelected, 'membership._id'), id => {
      if(membershipIds.indexOf(id) < 0) {
        membershipIds.push(id);
      }
    });

    // Get extra emails from baskets in one array
    let extraEmails: string[] = [];
    basketsSelected.forEach(basket => {
        basket.extraEmails.forEach(e => {
            if(extraEmails.indexOf(e) < 0) {
                extraEmails.push(e);
            }
        });
    });

    this.MessagesService.sendMail(this.message, membershipIds, extraEmails)
    .then( () => {
      this.alert = "The message has sent correctly for all the baskets selected!"
    });
  }

  ok() {
    (this as any).close();
  };

  cancel() {
    (this as any).dismiss({$value: 'cancel'});
  };
}


export default angular.module('terrappApp.adminBaskets')
  .component('adminBasketsMessages', {
    template: require('./adminBasketsMessages.html'),
    controller: adminBasketsMessagesComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;


// WEBPACK FOOTER //
// ./client/app/admin/adminBaskets/adminBasketsMessages.component.ts